export const FLU_CAMPAIGN_ID = 1;
export const COVID_CAMPAIGN_ID = 2;
